import React, { useMemo } from "react";
import { Paper, Box, Typography } from "@material-ui/core";
import intl from "react-intl-universal";

import { IWithballData } from "types";
import { EVENT_VALUES } from "modules/withball-data-input/constants";
import { groupPersonalData, personalData } from "utils";

import { MyPassPanel } from "./MyPassPanel";
import { MyDribblePanel } from "./MyDribblePanel";
import { MyShootPanel } from "./MyShootPanel";
import { MyDefensePanel } from "./MyDefensePanel";
import { MyPossessionPanel } from "./MyPossessionPanel";
import { MyDisciplinePanel } from "./MyDisciplinePanel";
import { MyTouchBallPanel } from "./MyTouchBallPanel";

interface IPlayerDataViewProps {
  playerId: string;
  dataArray: IWithballData[];
}

export const PlayerDataView = ({
  playerId,
  dataArray,
}: IPlayerDataViewProps) => {
  const { fromMeGroupedRecords, fromToMeGroupedRecords, fromMeData } =
    useMemo(() => {
      return {
        fromMeGroupedRecords: groupPersonalData(playerId, dataArray),
        fromToMeGroupedRecords: groupPersonalData(playerId, dataArray, true),
        fromMeData: personalData(playerId, dataArray),
      };
    }, [dataArray, playerId]);
  return (
    <>
      <Paper>
        <Box padding={2}>
          <Typography variant="h3">
            {intl.get("STATS_LABEL_TOUCH_BALL")}
          </Typography>
          <Box mt={2} />
          <MyTouchBallPanel
            dataArray={fromToMeGroupedRecords}
            playerId={playerId}
          />
        </Box>
      </Paper>
      <Paper>
        <Box padding={2}>
          <Typography variant="h3">{intl.get("STATS_LABEL_PASS")}</Typography>
          <Box mt={2} />
          <MyPassPanel
            dataArray={fromToMeGroupedRecords[EVENT_VALUES.PASS] || []}
            playerId={playerId}
          />
        </Box>
      </Paper>
      <Box mt={2} />
      <Paper>
        <Box padding={2}>
          <Typography variant="h3">
            {intl.get("STATS_LABEL_DRIBBLE")}
          </Typography>
          <Box mt={2} />
          <MyDribblePanel
            dataArray={fromToMeGroupedRecords[EVENT_VALUES.DRIBBLE] || []}
          />
        </Box>
      </Paper>
      <Box mt={2} />
      <Paper>
        <Box padding={2}>
          <Typography variant="h3">{intl.get("STATS_LABEL_SHOOT")}</Typography>
          <Box mt={2} />
          <MyShootPanel
            dataArray={fromMeGroupedRecords[EVENT_VALUES.SHOOT] || []}
            playerId={playerId}
          />
        </Box>
      </Paper>
      <Box mt={2} />
      <Paper>
        <Box padding={2}>
          <Typography variant="h3">
            {intl.get("STATS_LABEL_DEFENCE")}
          </Typography>
          <Box mt={2} />
          <MyDefensePanel
            tackleDataArray={fromToMeGroupedRecords[EVENT_VALUES.TACKLE] || []}
            interceptionDataArray={
              fromToMeGroupedRecords[EVENT_VALUES.INTERCEPTION] || []
            }
            clearanceDataArray={
              fromToMeGroupedRecords[EVENT_VALUES.CLEARANCE] || []
            }
          />
        </Box>
      </Paper>
      <Box mt={2} />
      <Paper>
        <Box padding={2}>
          <Typography variant="h3">{intl.get("STATS_POSSESSION")}</Typography>
          <Box mt={2} />
          <MyPossessionPanel dataArray={fromMeData || []} />
        </Box>
      </Paper>
      <Box mt={2} />
      <Paper>
        <Box padding={2}>
          <Typography variant="h3">
            {intl.get("STATS_LABEL_DISCIPLINE")}
          </Typography>
          <Box mt={2} />
          <MyDisciplinePanel
            foulDataArray={fromMeGroupedRecords[EVENT_VALUES.FOUL] || []}
            yellowCardDataArray={
              fromMeGroupedRecords[EVENT_VALUES.YELLOW] || []
            }
            redCardDataArray={fromMeGroupedRecords[EVENT_VALUES.RED] || []}
          />
        </Box>
      </Paper>
    </>
  );
};
